// https://stash.aexp.com/stash/projects/ONE/repos/amex-iguazu-resources/browse/src/memberPreferences.js
const memberPreferences = {
  fetch: ({ accountToken }, action, state) => ({
    url: `${state.getIn([
      'config',
      'mycaAPIUrl',
    ])}/servicing/v1/member/preferences`,
    opts: {
      headers: {
        account_token: accountToken,
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    },
  }),
};

export default memberPreferences;
